
export default {
  "nav.home": "Home",
  "nav.about": "About Us",
  "nav.portfolio": "Portfolio",
  "nav.partners": "Partners",
  "nav.contact": "Contact Us",
  "hero.title": "Excellence in Stainless Steel Engineering",
  "hero.subtitle": "Leading solutions with precision, quality, and innovation for over a decade",
  "hero.cta": "Get Quote",
  "hero.btn": "Learn More About Us",
  "about.title": "About JSPM Engineering",
  "about.subtitle": "Your Trusted Partner in Stainless Steel Solutions",
  "about.description": "JSPM Engineering Co., Ltd. has been established since 2004, with variety of high skilled technicians, specializes in high-quality stainless steel fabrication and engineering solutions. With over 20 years of experience, we serve diverse industries with precision manufacturing, custom designs, and reliable project delivery.",
  "about.experience": "Years of Experience",
  "about.projects": "Completed Projects",
  "about.clients": "Satisfied Clients",
  "portfolio.title": "Our Portfolio",
  "portfolio.subtitle": "Showcasing Excellence in Every Project",
  "portfolio.industrial": "Industrial Equipment",
  "portfolio.architectural": "Architectural Solutions",
  "portfolio.furniture": "Furniture Applications",
  "portfolio.food": "Food Grade Systems",
  "portfolio.modal.keyFeatures": "Key Features",
  "portfolio.modal.applications": "Applications",
  "portfolio.modal.close": "Close",
  "portfolio.industrial.description": "Specialized in manufacturing high-grade stainless steel equipment for industrial applications. Our solutions meet the highest standards for durability, corrosion resistance, and operational efficiency.",
  "portfolio.industrial.feature1": "Custom tank and vessel fabrication",
  "portfolio.industrial.feature2": "Precision welding and finishing",
  "portfolio.industrial.feature3": "Pressure vessel certification",
  "portfolio.industrial.feature4": "Quality control testing",
  "portfolio.industrial.feature5": "Installation and maintenance",
  "portfolio.industrial.app1": "Chemical processing plants",
  "portfolio.industrial.app2": "Pharmaceutical manufacturing",
  "portfolio.industrial.app3": "Oil and gas refineries",
  "portfolio.industrial.app4": "Power generation facilities",
  "portfolio.industrial.app5": "Water treatment systems",
  "portfolio.architectural.description": "Creating stunning architectural elements with stainless steel that combine aesthetic appeal with structural integrity. Our designs enhance modern buildings while ensuring longevity.",
  "portfolio.architectural.feature1": "Custom facade systems",
  "portfolio.architectural.feature2": "Decorative panels and screens",
  "portfolio.architectural.feature3": "Structural support elements",
  "portfolio.architectural.feature4": "Weather-resistant finishes",
  "portfolio.architectural.feature5": "Sustainable design solutions",
  "portfolio.architectural.app1": "Commercial building exteriors",
  "portfolio.architectural.app2": "Residential developments",
  "portfolio.architectural.app3": "Public infrastructure",
  "portfolio.architectural.app4": "Monument and sculpture work",
  "portfolio.architectural.app5": "Interior design elements",
  "portfolio.furniture.description": "Stainless steel furniture designed for strength, durability, and modern aesthetics. Perfect for both indoor and outdoor use.",
  "portfolio.furniture.feature1": "Custom designs to meet unique requirements",
  "portfolio.furniture.feature2": "Strong and durable structure",
  "portfolio.furniture.feature3": "Easy-to-clean polished stainless surfaces",
  "portfolio.furniture.feature4": "Suitable for residential and commercial spaces",
  "portfolio.furniture.feature5": "Long-lasting and cost-effective investment",
  "portfolio.furniture.app1": "Stainless steel tables and chairs",
  "portfolio.furniture.app2": "Stainless steel kitchen sets",
  "portfolio.furniture.app3": "Cabinets and shelving units",
  "portfolio.furniture.app4": "Outdoor stainless steel furniture",
  "portfolio.furniture.app5": "Commercial furniture for restaurants and cafés",
  "portfolio.food.description": "Food-grade stainless steel systems that meet the highest hygiene and safety standards. Our solutions ensure product quality and regulatory compliance in food processing environments.",
  "portfolio.food.feature1": "FDA-approved materials",
  "portfolio.food.feature2": "Sanitary design principles",
  "portfolio.food.feature3": "Easy-clean surfaces",
  "portfolio.food.feature4": "Temperature control systems",
  "portfolio.food.feature5": "Automated processing equipment",
  "portfolio.food.app1": "Food processing plants",
  "portfolio.food.app2": "Commercial kitchens",
  "portfolio.food.app3": "Beverage production facilities",
  "portfolio.food.app4": "Dairy processing systems",
  "portfolio.food.app5": "Restaurant equipment",
  "partners.title": "Trusted Partners",
  "partners.subtitle": "Collaborating with Industry Leaders",
  "partners.brochure": "View Company Profile",
  "contact.title": "Contact Us",
  "contact.subtitle": "Ready to Start Your Next Project?",
  "contact.address": "6/5 Moo 5 Ban Kluai - Sai Noi Rd. Phimon Rat, Bang Bua Thong, Nonthaburi 11110, Thailand",
  "contact.phone": "+66 (0)2-923-3732-3",
  "contact.email": "jspm2506@yahoo.com",
  "contact.form.name": "Full Name",
  "contact.form.email": "Email Address",
  "contact.form.company": "Company Name",
  "contact.form.phone": "Phone Number",
  "contact.form.project": "Project Details",
  "contact.form.submit": "Send Message",
  "footer.rights": "All rights reserved."
};
